module.exports = __webpack_public_path__ + "img/zl-on.1f38617c.png";